import React, { useState, useEffect } from 'react';
import { Table, Card, Tag, Input, Space, message } from 'antd';
import apiClient from '../services/api';

const Subscribers = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
  const [search, setSearch] = useState('');

  const fetchData = async (page = 1, pageSize = 20) => {
    setLoading(true);
    try {
      const res = await apiClient.get('/admin/newsletter/subscribers', {
        params: { page, per_page: pageSize, search },
      });
      const d = res.data;
      setData(d.data || []);
      setPagination((prev) => ({
        ...prev,
        current: d.current_page || page,
        total: d.total || 0,
      }));
    } catch {
      message.error('Failed to load subscribers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const handleSearch = (val) => {
    setSearch(val);
    fetchData(1, pagination.pageSize);
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (v) => <Tag color={v ? 'green' : 'red'}>{v ? 'Yes' : 'No'}</Tag>,
    },
    { title: 'Source', dataIndex: 'source', key: 'source' },
    { title: 'Subscribed At', dataIndex: 'created_at', key: 'created_at' },
  ];

  return (
    <Card title="Newsletter Subscribers">
      <Space style={{ marginBottom: 16 }}>
        <Input.Search
          placeholder="Search by email..."
          onSearch={handleSearch}
          allowClear
          style={{ width: 300 }}
        />
      </Space>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (t) => `Total ${t} subscribers`,
        }}
        onChange={(p) => fetchData(p.current, p.pageSize)}
      />
    </Card>
  );
};

export default Subscribers;
